<template>
	<div class=" investmentClues">
		<leftnav class="fl" :mkcode="(curWebsite.type == 5 || curWebsite.type == 6) ? 'T' : 'C'"
			:itemcode="(curWebsite.type == 5 || curWebsite.type == 6) ? 'T-CXQYRZ' : 'C-ZBZSXS'"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title"
							v-if="curWebsite.type != 5 && curWebsite.type != 6">{{ curWebsite.keyword }}{{ curWebsite.type == 2
								? '' : '线索' }}</span>
						<span class="fl right_title" v-if="curWebsite.type == 5 || curWebsite.type == 6">{{ curWebsite.type
							== 5 ? '投资' : "产业" }}动态</span>
						<cluetips v-if="curWebsite.type != 5 && curWebsite.type != 6"></cluetips>
						<video-teaching :type="3" seat="top"></video-teaching>
					</div>
					<!-- 筛选项开始 -->
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<!-- 招商版名字 资本招商 -->
							<ClueNav tabCode="zbzs" v-if="curWebsite.type != 5 && curWebsite.type != 6"></ClueNav>
							<!-- 投资版名字 创新企业融资 -->
							<dynamicNavTZ code="cxqyrz" v-if="curWebsite.type == 5 || curWebsite.type == 6"></dynamicNavTZ>
							<finacingTime v-on:chooseFinancing="chooseFinancing" :timetype="2"></finacingTime>
							<dl class="opport-screen bdbe">
								<dt class="fl">融资节点</dt>
								<dd class="fl">
									<span :class="node == 0 ? 'a-screen current' : 'a-screen'"
										@click="node = 0; getclue()">全部</span>
									<span :class="node == 3 ? 'a-screen current' : 'a-screen'"
										@click="node = 3; getclue()">孵化期</span>
									<span :class="node == 1 ? 'a-screen current' : 'a-screen'"
										@click="node = 1; getclue()">加速期</span>
									<span :class="node == 2 ? 'a-screen current' : 'a-screen'"
										@click="node = 2; getclue()">扩张期</span>
									<el-tooltip class="item smartTip-text listeltootipicon" effect="light"
										placement="top-start">
										<i class="el-icon-question"></i>
										<div slot="content" class="list_tips">
											<p>孵化期：已完成种子轮/天使轮融资的企业</p>
											<p>加速期：已完成PRE-A/A/A+轮融资的企业</p>
											<p>扩张期：已完成PRE-B/B/B+/C/C+/D轮融资的企业</p>
										</div>
									</el-tooltip>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">省份地区</dt>
								<dd class="fl">
									<span :class="provinceid == 0 ? 'current a-screen' : 'a-screen'"
										@click="provincechoose(0, 'all');">全国地区</span>
									<span :key="index" v-for="(item, index) in provincedata"
										@click="provincechoose(item.areaId, index);"
										:class="item.areaId == provinceid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
								</dd>
							</dl>

							<dl class="opport-screen bdbe" v-show="citydata.length != 0">
								<dt class="fl">城市地区</dt>
								<dd class="fl">
									<span :class="cityid == 0 ? 'current a-screen' : 'a-screen'"
										@click="choosecity(0, 'all'); ">全部</span>
									<span :key="index" v-for="(item, index) in citydata"
										@click="choosecity(item.areaId, index); " :data="item.areaId"
										:class="item.areaId == cityid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
								</dd>
							</dl>
							<!-- 20231010新增 -->
							<dl class="opport-screen bdbe" v-show="notionlist.length > 0">
								<dt class="fl">产业分类</dt>
								<dd class="fl screenop">
									<span @click="chooseNotion(1, 'a', { lable: '全部', value: 0, children: [] })"
										:class="notionCode == 0 ? 'a-screen current' : 'a-screen'">全部</span>
									<span :key="index" v-for="(item, index) in notionlist" v-if="item.label.indexOf('未来') < 0"
										:class="chooseNotionlist[0] == item.value ? 'a-screen current' : 'a-screen'"
										@click="chooseNotion(1, 'a', item)">{{ item.label }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="notionlist1.length > 0">
								<dt class="fl titleop">一级产业</dt>
								<dd class="fl">
									<span @click="chooseNotion(2, 'all', fenkd)"
										:class="chooseNotionlist[1] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
									<span :key="index" v-for="(item, index) in notionlist1"
										:class="chooseNotionlist[1] == item.value ? 'a-screen current' : 'a-screen'"
										@click="chooseNotion(2, 'a', item)">{{ item.label }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="notionlist2.length > 0">
								<dt class="fl titleop">二级细分</dt>
								<dd class="fl">
									<span @click="chooseNotion(3, 'all', fenkd)"
										:class="chooseNotionlist[2] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
									<span :key="index" v-for="(item, index) in notionlist2"
										:class="chooseNotionlist[2] == item.value ? 'a-screen current' : 'a-screen'"
										@click="chooseNotion(3, 'a', item)">{{ item.label }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="notionlist3.length > 0">
								<dt class="fl titleop">三级细分</dt>
								<dd class="fl">
									<span @click="chooseNotion(4, 'all', fenkd)"
										:class="chooseNotionlist[3] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
									<span :key="index" v-for="(item, index) in notionlist3"
										:class="chooseNotionlist[3] == item.value ? 'a-screen current' : 'a-screen'"
										@click="chooseNotion(4, 'a', item)">{{ item.label }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="notionlist4.length > 0">
								<dt class="fl titleop">四级细分</dt>
								<dd class="fl">
									<span @click="chooseNotion(5, 'all', fenkd)"
										:class="chooseNotionlist[4] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
									<span :key="index" v-for="(item, index) in notionlist4"
										:class="chooseNotionlist[4] == item.value ? 'a-screen current' : 'a-screen'"
										@click="chooseNotion(5, 'a', item)">{{ item.label }}</span>
								</dd>
							</dl>
						</div>
					</div>
					<!-- 筛选项结束 -->
				</div>
				<!-- 头部盒子结束 -->
				<!-- 表格内容开始 -->
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
					</div>
					<!-- 资本招商线索 -->
					<div class="enterprise_list_box">
						<!-- 创新企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-show="enterpristlist.length > 0">
							<tr>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<!-- <th>星级</th> -->
								<th>融资轮次</th>
								<th>融资时间</th>
								<th>融资金额</th>
								<th>地区</th>
								<th>投资方</th>
								<th>编辑</th>
							</tr>
							<tr :key="i" v-for="(list, i) in enterpristlist">
								<td class="title" @click="routerlinkid('enterprises', list.stockCode, 2, '', 'quality2')">
									{{ list.title }}</td>
								<td class="conpanytags hastag1" v-show="list.notion != ''">
									<span class="span-tag" :key="index" v-for="(item, index) in list.notionlist"
										@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name, 'quality2')">{{ item.name }}</span>
								</td>
								<td class="conpanytags" v-show="list.notion == ''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td>
								<td class="conpanytags hastag1" v-show="list.tag != ''">
									<span class="span-tag" :key="index" v-for="(item, index) in list.taglist"
										@click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name, 'quality2')">{{ item.name }}</span>
								</td>
								<td class="conpanytags" v-show="list.tag == ''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td>
								<!-- <td>
						<p class="stargrade" v-if="typeof(list.star) == 'number' && list.star > 0">
							<img src="../../assets/starfull.png" alt="" v-for="item in list.star">
							<img src="../../assets/star.png" alt="" v-for="item in (5-list.star)">
						</p>
						<span v-if="list.star == 0">-</span>
					</td> -->
								<td v-html="list.financingRound.length > 0 ? list.financingRound[0].rount : '-'"></td>
								<td v-html="list.financingRound.length > 0 ? list.financingRound[0].time : '-'"></td>
								<td v-html="list.financingRound.length > 0 ? list.financingRound[0].amount : '-'"></td>
								<td>{{ list.area }}</td>
								<td class="orglist">
									<p v-if="list.financingRound.length > 0"><span :key="inds"
											v-for="(org, inds) in list.financingRound[0].orgList" data="org.id"
											:class="org.id != 0 ? 'curp' : ''"
											@click="routerlinkid('investement-enterprises', org.id)">
											{{ org.orgName }}<i
												v-if="inds != list.financingRound[0].orgList.length - 1">、</i></span></p>
									<p v-if="list.financingRound.length == 0">-</p>
								</td>
								<td class="collectfont1"><span @click="listToggleCollect(list)">{{ list.collectId ==
									0 ? '加入' : '移除' }}<br />目标企业</span>
								</td>
							</tr>
						</table>


					</div>
					<!-- 表格内容结束 -->
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { dataInJs } from "../../utils/city.js";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'investmentClues',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {},
			curWebsite: this.$api.getWebsiteType(),
			searchtype: 3, //线索类型 2以商招商 1本省投资概率 3关键融资 4优质企业 
			searchtype1: 1, //创新企业融资
			fenkd: { children: [], value: 0 },
			finantime: '',
			notionlist: [],
			notionlist1: [],
			notionlist2: [],
			notionlist3: [],
			notionlist4: [],
			notiontext: '', notionCode: 0, chooseNotionlist: [0, 0, 0, 0, 0],
			node: 0,
			provincedata: dataInJs(),
			countydata: [],
			citydata: [],
			provinceid: 0,
			cityid: 0,
			countyid: 0,
			enterpristlist: [],
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数 
			totalPage: 1,
			maxPage: 10, //最大页数   
		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		var _this = this;
		this.userdata = this.getuserinformain();
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		this.pro = this.userdata.province;
		// this.finantime = this.financingTime[0].time;
		// console.log(1111111,this.finantime);
		this.getclue();
		this.getNotionList();
		// this.getareaclue(this.pro);
	},
	methods: {
		//接收子元素传过来的时间
		receive(date1, date2) {
			this.finantime = date1;
			this.finantime2 = date2;
			this.getclue();
		},
		//获取概念分类
		getNotionList() {
			var _this = this;
			this.$axios.get(this.$api.tag.notion.list() + '?level=5', {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					_this.notionlist = res.data.list == null ? [] : res.data.list;
				} else {
					_this.tokenfailed(res.data.msg);
				}
			});
		},
		//概念单选 层级显示
		chooseNotion(step, type, data) {
			if (type == 'all') {
				this.notionCode = this.chooseNotionlist[step - 2];
				this.chooseNotionlist[step - 1] = '0';
			} else {
				this.chooseNotionlist[step - 1] = data.value;
				for (var i = 0; i < this.chooseNotionlist.length; i++) {
					if (i > step - 1) {
						this.chooseNotionlist[i] = '0';
					}
				}
				this.notionCode = data.value;
			}
			if (data.children != null) {
				if (step == 1) {
					this.notionlist1 = data.children.filter(list => {
						return list.label != '环保';
					});
					// console.log(this.notionlist1)
					this.notionlist2 = []; this.notionlist3 = []; this.notionlist4 = [];
				} else if (step == 2) {
					this.notionlist2 = data.children;
					this.notionlist3 = []; this.notionlist4 = [];
				} else if (step == 3) {
					this.notionlist3 = data.children; this.notionlist4 = [];
				} else if (step == 4) {
					this.notionlist4 = data.children; this.notionlist5 = [];
				} else if (step == 5) {
					this.notionlist5 = data.children;
				}
			}
			// console.log(this.chooseNotionlist);
			this.getclue();
		},
		//融资时间筛选
		chooseFinancing(time1) {
			this.finantime = time1 == 'year' ? '' : time1;
			this.getclue();
		},
		choosecityide(art) {
			this.choosecityid(art[0], art[1]);
		},
		//省份城市选择
		provincechoose(id, i) {
			this.provinceid = id;
			this.cityid = 0;
			this.countyid = 0;
			this.countydata = [];
			if (i != "all" && this.provincedata[i].children != null) {
				this.citydata = this.provincedata[i].children;
			} else {
				this.citydata = [];
			}
			this.page = 1;
			this.getclue();
		},
		choosecity(id, i) {
			//	console.log('choosecity',id);
			this.cityid = id;
			this.countyid = 0;
			if (i != "all" && this.citydata[i].children != null) {
				this.countydata = this.citydata[i].children;
			} else {
				this.countydata = [];
			}
			this.page = 1;
			this.getclue();
		},
		//获取产业链/区域/融资企业招商线索
		//获取产业链/区域/融资企业招商线索
		getclue(pages) {
			var _this = this,
				ajaxurl = '';
			_this.bus.$emit('loading', true);
			this.page = pages ? pages : 1;
			var notionja = this.splicing('notion', this.notionCode);
			ajaxurl = this.$api.cyl.investclue.capital() + '?step=' + this.node + '&time=' + this.finantime +
				'&province=' + this.provinceid + '&city=' + this.cityid + '&page=' + this.page + notionja;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				// console.log(_this.searchtype, "招商", res, ajaxurl);
				if (res.data.success) {
					_this.enterpristlist = res.data.list;
					for (var i = 0; i < res.data.list.length; i++) {
						_this.enterpristlist[i].notionlist = _this.taglistfun(_this.enterpristlist[i].notion,
							_this.enterpristlist[i].notionCode);
						_this.enterpristlist[i].taglist = _this.taglistfun(_this.enterpristlist[i].tag, _this
							.enterpristlist[i].tagCode);
					}
					_this.bus.$emit('loading', false);
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
				} else {
					_this.tokenfailed(res.data.msg);
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		pageHandler: function (page) {
			this.getclue(page);
		},
	},
}
</script>

<style>/* 提示框箭头 */
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
	border-top-color: #E0E8F9;
}

.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
	border-top-color: #E0E8F9;
}

/* 提示框背景色 */
.atooltip {
	background: #E0E8F9 !important;
}</style>